import angular from 'angular';

angular.module("merchant.application.main").factory("merchant.application.main.factory.geocoder",
    function() {
        var geocoder = new google.maps.Geocoder();
        var expose = {};

        expose.parseAddress = function(address, success, error) {
            geocoder.geocode(address, function(results, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    success(results);
                } else {
                    error();
                }
            });
        };

        return expose;
    }
);
